module.exports = __webpack_public_path__ + "static/media/icon-supplies-soap.d9a2b745.svg";